import { PeriscopeV3PaginatedList } from '..';
import { useQueryResource } from '@hooks';
import { WorkflowRuleRow } from './WorkflowRuleRow';
import { WorkflowRuleSearch } from '.';
import { InactiveToggleQueryParams, SearchFilterQueryParams } from '../filters';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import {
	KeyPaginationQueryParams,
	OffsetPaginatedResource,
	PeriscopeSfWorkflowRule
} from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

type Resource = OffsetPaginatedResource<PeriscopeSfWorkflowRule>;
export type SearchablePeriscopeV3WorkflowRuleListQueryParams = InactiveToggleQueryParams &
	KeyPaginationQueryParams &
	SearchFilterQueryParams;

export interface SearchablePeriscopeV3WorkflowRuleListProps {
	parentIndex: number;
	uri: string;
}

const defaultParams: SearchablePeriscopeV3WorkflowRuleListQueryParams = {
	...keyPaginationDefaultQueryParams,
	hideInactive: true
};

export const SearchablePeriscopeV3WorkflowRuleList: React.FC<SearchablePeriscopeV3WorkflowRuleListProps> = ({
	parentIndex,
	uri
}) => {
	const { loading, resource, queryParams, updateParams } = useQueryResource<
		Resource,
		SearchablePeriscopeV3WorkflowRuleListQueryParams
	>({
		defaultParams,
		fallbackParams: keyPaginationFallbackQueryParams,
		uri
	});

	const renderRules = useCallback(
		(rule: PeriscopeSfWorkflowRule) => <WorkflowRuleRow
			parentIndex={ parentIndex }
			rule={ rule } />,
		[ parentIndex ]
	);

	return (
		<>
			<WorkflowRuleSearch
				onChange={ updateParams }
				queryParams={ queryParams } />
			<PeriscopeV3PaginatedList
				loading={ loading }
				onChange={ updateParams }
				queryParams={ queryParams }
				renderListItem={ renderRules }
				resource={ resource } />
		</>
	);
};
